import { render, staticRenderFns } from "./yc-header.vue?vue&type=template&id=3a324fcd&"
import script from "./yc-header.vue?vue&type=script&lang=ts&"
export * from "./yc-header.vue?vue&type=script&lang=ts&"
import style0 from "./yc-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports